export const STARS = {
  TAO_HOA: {
    Ty: 'Mao',
    Ngo: 'Dau',
    Dan: 'Hoi',
    Than: 'Ty_'
  },
  THIEN_AT_QUY_NHAN: {
    Giap: ['Mui', 'Suu'],
    At: ['Than', 'Ty'],
    Binh: ['Hoi', 'Dau'],
    Dinh: ['Hoi', 'Dau'],
    Mau: ['Mui', 'Suu'],
    Ky: ['Than', 'Ty'],
    Canh: ['Mui', 'Suu'],
    Tan: ['Dan', 'Ngo'],
    Nham: ['Mao', 'Ty_'],
    Quy: ['Mao', 'Ty_']
  },
  THIEN_DUC_QUY_NHAN: {
    Giap: ['Dau'],
    At: ['Than'],
    Binh: ['Hoi'],
    Dinh: ['Dau'],
    Mau: ['Suu'],
    Ky: ['Ty'],
    Canh: ['Dan'],
    Tan: ['Mao'],
    Nham: ['Than'],
    Quy: ['Ngo']
  },
  VAN_XUONG: {
    Giap: ['Ty_'],
    At: ['Ngo'],
    Binh: ['Than'],
    Dinh: ['Dau'],
    Mau: ['Than'],
    Ky: ['Dau'],
    Canh: ['Hoi'],
    Tan: ['Ty'],
    Nham: ['Dan'],
    Quy: ['Mao']
  },
  VAN_KHUC: {
    Giap: ['Thin'],
    At: ['Ty_'],
    Binh: ['Mui'],
    Dinh: ['Than'],
    Mau: ['Mui'],
    Ky: ['Than'],
    Canh: ['Tuat'],
    Tan: ['Hoi'],
    Nham: ['Suu'],
    Quy: ['Dan']
  },
  HOA_CAI: {
    Hoi: 'Mui',
    Mao: 'Mui',
    Mui: 'Mui',
    Dan: 'Tuat',
    Ngo: 'Tuat',
    Tuat: 'Tuat',
    Than: 'Thin',
    Ty: 'Thin',
    Thin: 'Thin',
    Ty_: 'Suu',
    Dau: 'Suu',
    Suu: 'Suu'
  },
  CO_THAN: {
    Hoi: 'Dan',
    Ty: 'Dan',
    Suu: 'Dan',
    Dan: 'Ty_',
    Mao: 'Ty_',
    Thin: 'Ty_',
    Ty_: 'Than',
    Ngo: 'Than',
    Mui: 'Than',
    Than: 'Hoi',
    Dau: 'Hoi',
    Tuat: 'Hoi'
  },
  QUA_TU: {
    Hoi: 'Tuat',
    Ty: 'Tuat',
    Suu: 'Tuat',
    Dan: 'Suu',
    Mao: 'Suu',
    Thin: 'Suu',
    Ty_: 'Thin',
    Ngo: 'Thin',
    Mui: 'Thin',
    Than: 'Mui',
    Dau: 'Mui',
    Tuat: 'Mui'
  },
  KIEP_SAT: {
    Hoi: 'Ty_',
    Mao: 'Ty_',
    Mui: 'Ty_',
    Dan: 'Than',
    Ngo: 'Than',
    Tuat: 'Than',
    Than: 'Dan',
    Ty: 'Dan',
    Thin: 'Dan',
    Ty_: 'Hoi',
    Dau: 'Hoi',
    Suu: 'Hoi'
  },
  TRAM_SAT: {
    Hoi: 'Dau',
    Mao: 'Dau',
    Mui: 'Dau',
    Dan: 'Ty',
    Ngo: 'Ty',
    Tuat: 'Ty',
    Than: 'Ngo',
    Ty: 'Ngo',
    Thin: 'Ngo',
    Ty_: 'Mao',
    Dau: 'Mao',
    Suu: 'Mao'
  },
  THIEN_LA_DIA_VONG: ['Thin', 'Tuat']
};

const addStarIfMatch = (stars, name, pillar) => {
  stars.push({
    name,
    pillar: pillar.label,
    branch: pillar.chi
  });
};

const addStarsByBranches = (stars, name, pillars, branches = []) => {
  if (!branches.length) return;
  Object.values(pillars).forEach((pillar) => {
    if (branches.includes(pillar.chi)) {
      addStarIfMatch(stars, name, pillar);
    }
  });
};

export function findStars(pillars) {
  const stars = [];
  const yearBranch = pillars.year.chi;

  const taoHoaBranch = STARS.TAO_HOA[yearBranch];
  if (taoHoaBranch) {
    Object.values(pillars).forEach((pillar) => {
      if (pillar.chi === taoHoaBranch) {
        addStarIfMatch(stars, 'Đào Hoa', pillar);
      }
    });
  }

  const dayStem = pillars.day.can;
  const nobleBranches = STARS.THIEN_AT_QUY_NHAN[dayStem] || [];
  addStarsByBranches(stars, 'Thiên Ất Quý Nhân', pillars, nobleBranches);

  const thienDucBranches = STARS.THIEN_DUC_QUY_NHAN[dayStem] || [];
  addStarsByBranches(stars, 'Thiên Đức Quý Nhân', pillars, thienDucBranches);

  const vanXuongBranches = STARS.VAN_XUONG[dayStem] || [];
  addStarsByBranches(stars, 'Văn Xương', pillars, vanXuongBranches);

  const vanKhucBranches = STARS.VAN_KHUC[dayStem] || [];
  addStarsByBranches(stars, 'Văn Khúc', pillars, vanKhucBranches);

  const hoaCaiBranch = STARS.HOA_CAI[yearBranch];
  addStarsByBranches(stars, 'Hoa Cái', pillars, hoaCaiBranch ? [hoaCaiBranch] : []);

  const coThanBranch = STARS.CO_THAN[yearBranch];
  addStarsByBranches(stars, 'Cô Thần', pillars, coThanBranch ? [coThanBranch] : []);

  const quaTuBranch = STARS.QUA_TU[yearBranch];
  addStarsByBranches(stars, 'Quả Tú', pillars, quaTuBranch ? [quaTuBranch] : []);

  const kiepSatBranch = STARS.KIEP_SAT[yearBranch];
  addStarsByBranches(stars, 'Kiếp Sát', pillars, kiepSatBranch ? [kiepSatBranch] : []);

  const tramSatBranch = STARS.TRAM_SAT[yearBranch];
  addStarsByBranches(stars, 'Trạm Sát', pillars, tramSatBranch ? [tramSatBranch] : []);

  const branchSet = new Set(Object.values(pillars).map((pillar) => pillar.chi));
  if (STARS.THIEN_LA_DIA_VONG.every((branch) => branchSet.has(branch))) {
    stars.push({
      name: 'Thiên La Địa Võng',
      pillar: 'Tu Tru',
      branch: STARS.THIEN_LA_DIA_VONG.join('-')
    });
  }

  return stars;
}
